<template>
  <div class="csv-viewer_container">
    <table class="csv-viewer" v-if="csvData.length">
      <thead>
        <tr>
          <th v-for="(header, index) in csvData[0]" :key="index">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in csvData.slice(1)" :key="rowIndex">
          <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
    <p v-else>Loading...</p>
  </div>
</template>

<script setup>
import { ref, onMounted, watchEffect } from "vue";
import Papa from "papaparse";
import { useStore } from "vuex";

const csvData = ref([]);

const props = defineProps({
  documentName: String,
});

const store = useStore();

// Function to parse the CSV Blob
const parseCsvBlob = async (blob) => {
  if (!blob) return;

  try {
    const csvText = await blob.text(); // Convert Blob to text

    Papa.parse(csvText, {
      complete: (result) => {
        csvData.value = result.data;
      },
      header: false, // Set to true if your CSV has headers
    });
  } catch (error) {
    console.error("Error parsing CSV Blob:", error);
  }
};

// Automatically update when `documentName` changes
watchEffect(() => {
  const csv = store.getters.getDocumentById(props.documentName);

  if (csv?.FileBytes) {
    parseCsvBlob(csv.FileBytes);
  }
});

</script>

<style scoped>

.csv-viewer {
  background-color: #fff;
}

.csv-viewer_container {
  overflow: scroll;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f4f4f4;
}

</style>
